export const API_URL = "https://journey-api.espresso-cloud.com";
export const WS_URL = "wss://journey-chat.elabs.xyz";